import * as THREE from "three";
import { SceneDimmer } from "./scene_dimmer.js";

const SKY_TOP = "#0067F3";
const SKY_BOTTOM = "#A5E9FF";
const SKY_GRADIENT_END = 0.22;
const SKY_BAND_HEIGHT = 0.23;

export const GlobalUniforms = {
  uCurveX: { value: 0 }
};

export class SceneManager
{
  static scene: THREE.Scene;
  static world: THREE.Group;
  static camera: THREE.PerspectiveCamera;
  static sky: THREE.Mesh;

  static init()
  {
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color( SKY_BOTTOM );
    this.sky = this.createSkyBand();
    this.scene.add( this.sky );

    this.world = new THREE.Group();
    this.scene.add( this.world );

    return this.scene;
  }

  private static createSkyBand(): THREE.Mesh
  {
    const bottom = 1 - 2 * SKY_BAND_HEIGHT;
    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute( "position", new THREE.Float32BufferAttribute( [ -1, bottom, 0, 1, bottom, 0, 1, 1, 0, -1, 1, 0 ], 3 ) );
    geometry.setIndex( [ 0, 1, 2, 0, 2, 3 ] );

    const material = new THREE.ShaderMaterial( {
      uniforms: { map: { value: this.createLobbySkyGradient() } },
      vertexShader: "varying vec2 vUv;\nvoid main() {\n\tvUv = position.xy * 0.5 + 0.5;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
      fragmentShader: "uniform sampler2D map;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( map, vUv );\n\t#include <colorspace_fragment>\n}",
      depthTest: false,
      depthWrite: false,
    } );

    const mesh = new THREE.Mesh( geometry, material );
    mesh.frustumCulled = false;
    mesh.renderOrder = -10000;
    mesh.layers.enable( SceneDimmer.BACKGROUND_LAYER );
    return mesh;
  }

  private static createLobbySkyGradient(): THREE.CanvasTexture
  {
    const canvas = document.createElement( "canvas" );
    canvas.width = 2;
    canvas.height = 512;

    const ctx = canvas.getContext( "2d" )!;
    const gradient = ctx.createLinearGradient( 0, 0, 0, canvas.height * SKY_GRADIENT_END );
    gradient.addColorStop( 0, SKY_TOP );
    gradient.addColorStop( 1, SKY_BOTTOM );
    ctx.fillStyle = gradient;
    ctx.fillRect( 0, 0, canvas.width, canvas.height );

    const texture = new THREE.CanvasTexture( canvas );
    texture.colorSpace = THREE.SRGBColorSpace;
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
    return texture;
  }

  static update( dt: number ): void
  {
  }
}
